module.exports = __webpack_public_path__ + "img/PRCA1_CD4Tconv.8bbc0eee.png";